// extracted by mini-css-extract-plugin
export default {"container":"SelectScreen_container__DHA1R AuthScreen_container__Ef0En","headerText":"SelectScreen_headerText__+-HTJ","cardsContainer":"SelectScreen_cardsContainer__w0lRV"};